"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PPTooltip_1 = __importDefault(require("../PPTooltip"));
var TopBarItem = function (props) {
    var _a, _b;
    return (react_1.default.createElement(PPTooltip_1.default, { content: (_a = props.tooltip) === null || _a === void 0 ? void 0 : _a.label, position: (_b = props.tooltip) === null || _b === void 0 ? void 0 : _b.position, trigger: 'hover' },
        react_1.default.createElement("div", { onClick: function () { return props.onClick(); }, className: "item".concat(props.selected ? ' selected' : '') },
            props.icon &&
                react_1.default.createElement("i", { className: "icon ".concat(props.icon) }),
            props.selected && props.name &&
                react_1.default.createElement("span", { className: "title" }, props.name))));
};
exports.default = TopBarItem;
